//设备
import * as historyApi from '@/api/maintain/plant/list'
import {getLanguageStr} from "@/util/language"

const state = {
    equipment: [], //设备列表
    relevantPerson: [], //人员列表
    relevantId: '', //关联人员ID
    pagination: {},
    isOpen: false, //详情是否是展开页面
    metering:{},
    stationId: '',
    currentIndex: 0,
    deviceIndex:0,
    btnGroup: [{
        title: getLanguageStr("word734","详情"),
        // Perms: 'A/B/F'
    }, {
        title:getLanguageStr("word1968","子系统/设备")
        // Perms: 'A/B/F'
    },
    {
        title: getLanguageStr("word27","报警"),
        // Perms: 'A/B/F'
    },
    {
        title: getLanguageStr("word733","电站信息"),
        // Perms: 'A/B/F'
    }],
    recordId: {
        relevantPersonUrl: '',
        equipmentUrl: ''
    },
    isEmpty: true,
    weather:[{temp:null,weatherPic:null}],
    summary:{}
}
const getters = {
    equipment: state => {
        return state.equipment
    },
    stationId: state => {
        return state.stationId
    },
    deviceIndex: state => {
        return state.deviceIndex
    },
    currentIndex: state => {
        return state.currentIndex
    },
    btnGroup: state => {
        return state.btnGroup
    },
    recordId: state => {
        return state.recordId
    },
    pagination: state => {
        return state.pagination
    },
    isEmpty: state => {
        return state.isEmpty
    },
    isOpen: state => {
        return state.isOpen
    },
    metering:state=>state.metering,
    relevantPerson: state => {
        return state.relevantPerson
    },
    relevantId: state => {
        return state.relevantId
    },
    weather:state=>{
        return state.weather
    },
    summary:state=>{
        return state.summary
    }
}
const actions = {
    // 设备
    GetEquipment({ commit }, pages) {
        let apiName
        commit('GET_EQUIPMENT',[])
        switch (pages.equipTabIndex){
            case 0:
                apiName = "OperationCollector";
                break;
            case 1:
                apiName = "OperationAmmeter";
                break;
            case 2:
                apiName = "OperationInverter";
                break;
            default:
                apiName = "OperationCollector";
                break;
        }
        return new Promise((resolve, reject) => {
            commit('GET_ISEMPTY', true)
            historyApi[apiName](state.stationId, pages).then(response => {
                // console.log(response)
                response.data = response.data || [];
                if (pages.equipTabIndex==0) {
                    response.data.map(el => {
                        el.showInverter = false
                    })
                }
                commit('Get_RECORDID', { equipmentUrl: `equipment/${state.stationId}` })
                commit('GET_EQUIPMENT', response.data)
                let { total } = response
                state.pagination = {...state.pagination, total }
                commit('GET_PAGINATION', state.pagination)
                commit('GET_ISEMPTY', false)
                resolve()
            }).catch(error => {
                commit('GET_ISEMPTY', false)
                reject(error)
            })
        })
    },
    // 关联人员
    GetPerson({ commit }, pages) {
        return new Promise((resolve, reject) => {
            commit('GET_ISEMPTY', true)
                // let total
                // let hasCg = 0
            historyApi.AssociatedPerson(state.stationId, pages).then(response => {
                let result = response.data
                    // if (response.data.length != 0) {
                    //     for (let attr in response.data) {
                    //         if (response.data[attr].role.roleName === '超级管理员') {
                    //             result.splice(attr, 1)
                    //             hasCg++
                    //         }
                    //     }
                    // }
                    // if (hasCg > 0) {
                    //     total = response.total - 1
                    // } else {
                    //     total = response.total
                    // }
                commit('Get_RECORDID', { relevantPersonUrl: `person/${state.stationId}` })
                commit('Get_person', result)
                let { total } = response
                state.pagination = {...state.pagination, total }
                commit('GET_PAGINATION', state.pagination)
                commit('GET_ISEMPTY', false)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {
    GET_EQUIPMENT: (state, equipment) => {
        state.equipment = equipment
    },
    GET_STATIONID: (state, id) => {
        state.stationId = id
    },
    GET_DEVICEINDEX: (state, index) => {
        state.deviceIndex = index
    },
    GET_CURRENTINDEX: (state, index) => {
        state.currentIndex = index
    },
    GET_BTNGROUP(state) {
        let buttonPermsStr = localStorage.getItem('buttonPermissions')
        let buttonPerms = JSON.parse(buttonPermsStr)
        if (buttonPerms != null) {
            state.btnGroup = state.btnGroup.slice(0, 4)
            let reversePerms = buttonPerms.sort().reverse()
            reversePerms.map(el => {
                if (el == 'A/D/A') {
                    state.btnGroup.push({ title: getLanguageStr("manage76","成员"), Perms: 'A/D/A' })
                } else if (el == 'A/C/A') {
                    state.btnGroup.push({ title: getLanguageStr("word164","设备"), Perms: 'A/C/A' })
                }
            })
        }
    },
    GET_METERING:(state,item)=>{
        state.metering=item
    },
    Get_RECORDID: (state, item) => {
        for (let attr in item) {
            state.recordId[attr] = item[attr]
        }
    },
    GET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },
    GET_ISEMPTY: (state, isEmpty) => {
        state.isEmpty = isEmpty
    },
    Get_person: (state, relevantPerson) => {
        state.relevantPerson = relevantPerson
    },
    GET_PERSONID: (state, personId) => {
        state.relevantId = personId
    },
    GET_ISOPEN: (state, isOpen) => {
        state.isOpen = isOpen
    },
    GET_WEATHER:(state,weather)=>{
        state.weather=weather
    },
    GET_SUMMARY:(state,summary)=>{
        state.summary=summary
    }

}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/stationDetail.js